var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12843",
    "data-name": "Group 12843",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2200",
    "data-name": "Rectangle 2200",
    width: 36,
    height: 50,
    fill: "#c2c2c2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12842",
    "data-name": "Group 12842",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12748",
    "data-name": "Path 12748",
    d: "M0,24.859Q0,13.542,0,2.225C0,.009,0,.008,2.237.008c6.786,0,13.572-.033,20.357.043a3.765,3.765,0,0,1,2.38.965Q30.1,6.045,35.042,11.275a3.675,3.675,0,0,1,.915,2.285C36.015,25.007,36,36.454,36,47.9c0,2.082-.021,2.1-2.051,2.1Q17.95,50,1.955,50C.041,50,0,49.961,0,47.961q0-11.552,0-23.1m34.226-11.5c-2.586,0-5.029.014-7.473,0-4.529-.033-3.787.51-3.838-3.855-.03-2.579-.006-5.159-.006-7.731H1.794V48.266H34.227Z",
    transform: "translate(0 -0.001)",
    fill: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12749",
    "data-name": "Path 12749",
    d: "M74.179,66.7a2.408,2.408,0,0,1,2.412,2.449,2.451,2.451,0,0,1-2.344,2.535,2.549,2.549,0,0,1-2.529-2.545,2.5,2.5,0,0,1,2.461-2.44",
    transform: "translate(-49.642 -45.761)",
    fill: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12750",
    "data-name": "Path 12750",
    d: "M31.806,71.683a2.452,2.452,0,0,1-2.4-2.476,2.41,2.41,0,0,1,2.5-2.508,2.489,2.489,0,0,1,2.358,2.534,2.527,2.527,0,0,1-2.461,2.45",
    transform: "translate(-20.355 -45.76)",
    fill: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12751",
    "data-name": "Path 12751",
    d: "M49.689,97.331a.777.777,0,0,1-.77-.785,4.885,4.885,0,1,0-9.767,0,.77.77,0,1,1-1.539,0,6.424,6.424,0,1,1,12.845,0,.777.777,0,0,1-.77.785",
    transform: "translate(-26.035 -61.745)",
    fill: "#c2c2c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.e484c3a2ef0d2b944e2fdbbbb34919e2.svg";
export { ForwardRef as ReactComponent };